<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology<sup>®</sup> Cadillac</h2>
        <h3>Unmatched versatility with that classic feel</h3>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml" @openModal="openModal" @isVideo="initModal" id="1">
            <photo
              @setFeature="setFeatureImg"
              @setId="setId"
              @isVideo="initModal"
              src="Cadillac_Contrology_Video_Thumb@1x.jpg"
              src2="Cadillac_Contrology_Video_Thumb@2x.jpg"
              alt="Photo of woman assembling a Contrology Cadillac"
              video
              id="1"
            />
            <photo
              @setFeature="setFeatureImg"
              @setId="setId"
              src="contrology-cad1@1x.jpg"
              src2="contrology-cad1@2x.jpg"
              alt="Photo of Contrology Cadillac"
              id="2"
            />
            <photo
              @setFeature="setFeatureImg"
              @setId="setId"
              src="contrology-cad2@1x.jpg"
              src2="contrology-cad2@2x.jpg"
              alt="Detail photo of Contrology Cadillac"
              id="3"
            />
            <photo
              @setFeature="setFeatureImg"
              @setId="setId"
              src="contrology-cad3@1x.jpg"
              src2="contrology-cad3@2x.jpg"
              alt="Detail photo of Contrology Cadillac legs"
              id="4"
            />
            <photo
              @setFeature="setFeatureImg"
              @setId="setId"
              src="contrology-cad5@1x.jpg"
              src2="contrology-cad5@2x.jpg"
              alt="In-use photo of Contrology Cadillac"
              id="5"
            />
            <photo
              @setFeature="setFeatureImg"
              @isVideo="initModal"
              @setId="setId"
              src="contrology-cad6@1x.jpg"
              src2="contrology-cad6@2x.jpg"
              alt="Photo of woman assembling a Contrology Cadillac"
              caption="Cadillac with toybox shown"
              video
              id="6"
            />
          </photo-grid>

          <!-- <cta-button class="cta-button wide" /> -->

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology<sup>®</sup> Cadillac</h2>
              <h3>Unmatched versatility with that classic feel</h3>
              <p>
                Engineered for maximum stability, efficient adjustment and safe use for both instructors and clients, the stunning Contrology Cadillac features a weld-free integrated aluminum base with a galvanized, polished steel canopy.
                <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span>
              </p>
              <div v-show="show">
                <p>Specially-developed Springs (leg, arm, PTB and RBB) provide the authentic feel of original Pilates apparatus. The premium upholstered tabletop mat is made of dense, resilient foam, for maximum feedback during use. Underneath the mat is the option for a hidden “toybox” - perfect for storing springs and props.
                <!-- <p>Please review <a href="https://s3.amazonaws.com/s3.pilates.com/resources/Contrology_WeightLimits_CapitalEquipment.pdf" class="content-link">equipment weight limits</a>. -->
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div>
            </section>

           <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
              additionalText="19-day lead time"
            />

            <!-- Patent info -->
            <p class="part-number patent-info">
              <a href="https://www.pilates.com/company/balanced-body-patent-data">Click here</a> for <span style="font-weight: 500;">Balanced Body Patent Data</span>.
            </p>

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >10-Year Warranty</icon-link>
              <icon-link
                url="support-cadillac"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
              <icon-link
                img="icon-upholstery.svg"
                alt="Upholstery icon"
              >Stock Upholstery: Black</icon-link>
              <icon-link
                img="icon-upholstery-colors.svg"
                alt="Color upholstery icon"
                title="Open modal"
                url="#"
                @open="showCardModal = true"
              >Upholstery Options</icon-link>
              <icon-link
                url="#accessories"
                title="See the accessories"
                img="icon-accessories.svg"
                alt="Accessories icon"
              >Accessories</icon-link>
            </section>

            <modal-card-large v-if="showCardModal" @close="showCardModal = false" />

            <cta-button class="cta-button" />
          </div>
        </div>

        <section class="product-info">
          <prod-accordion class="accordion-wrapper" title="Features" animation="reveal">
            <ul class="features">
              <li>Integrated weld-free aluminum base engineered for durability and stability</li>
              <li>Canopy vertical tubing inserts the full length of legs for significantly enhanced rigidity and stability</li>
              <li>Galvanized, polished schedule 80 steel pipe in canopy nearly doubles strength of all pipe in canopy system</li>
              <li>Tabletop made of thin, dense, resilient foam for optimal “feel” while exercising</li>
              <li>Slider knobs intentionally placed on side of slider (not on top!) for easier access while exercising and teaching</li>
              <li>Vintage forged steel eye bolts on Push-Thru Bar are stronger and distinctive</li>
              <li>Adjustable clasp on belly strap enables user to tailor fit to foot size (and readjusts easily with no need for knots!)</li>
              <li>Optional “toybox” serves as storage for accessories and props (no more clutter under the bench!)</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Included" animation="reveal">
            <ul class="included">
              <li>Wooden Push-Through Bar (PTB)</li>
              <li>Wood Roll Back Bar 31.25” (79.4cm) with metal “s” hooks</li>
              <li>Trap Bar with footstrap</li>
              <li>2 Contrology Arm Springs (light) with leather handles</li>
              <li>2 Contrology Leg Springs (light) with cotton loops</li>
              <li>2 Contrology Roll Back Bar Springs</li>
              <li>2 Contrology Trap Bar Springs</li>
              <li>3 Contrology PTB Springs</li>
              <li>2 Safety chains and 1 Storage chain</li>
              <li>Large Kuna Board<br/>6“ (15.3cm) wide x 1.5” (3.8cm) deep x 29” (73.7cm) long</li>
              <li>Adjustable Belly Strap</li>
              <li>18" footstrap</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Dimensions" animation="reveal">
            <p>Width: 25.5" (64.8cm)</p>
            <p>Length 86” (218,4cm)</p>
            <p>Canopy Height 82” (208.3cm)</p>
            <p>Table Height: 23.7" (60.2cm)</p>
            <p>Weight: 245lbs. (111.1kg)</p>
            <p>Weight (with toybox): 280lbs (127kg)</p>
          </prod-accordion>

          <tabs>
            <tab name="Features" :selected="true">
              <ul class="features">
                <li>Integrated weld-free aluminum base engineered for durability and stability</li>
                <li>Canopy vertical tubing inserts the full length of legs for significantly enhanced rigidity and stability</li>
                <li>Galvanized, polished schedule 80 steel pipe in canopy nearly doubles strength of all pipe in canopy system</li>
                <li>Tabletop made of thin, dense, resilient foam for optimal “feel” while exercising</li>
                <li>Slider knobs intentionally placed on side of slider (not on top!) for easier access while exercising and teaching</li>
                <li>Vintage forged steel eye bolts on Push-Thru Bar are stronger and distinctive</li>
                <li>Adjustable clasp on belly strap enables user to tailor fit to foot size (and readjusts easily with no need for knots!)</li>
                <li>Optional “toybox” serves as storage for accessories and props (no more clutter under the bench!)</li>
              </ul>
            </tab>
            <tab name="Included">
              <ul class="included">
                <li>Wooden Push-Through Bar (PTB)</li>
                <li>Wood Roll Back Bar 31.25” (79.4cm) with metal “s” hooks</li>
                <li>Trap Bar with footstrap</li>
                <li>2 Contrology Arm Springs (light) with leather handles</li>
                <li>2 Contrology Leg Springs (light) with cotton loops</li>
                <li>2 Contrology Roll Back Bar Springs</li>
                <li>2 Contrology Trap Bar Springs</li>
                <li>3 Contrology PTB Springs</li>
                <li>2 Safety chains and 1 Storage chain</li>
                <li>Large Kuna Board<br/>6“ (15.3cm) wide x 1.5” (3.8cm) deep x 29” (73.7cm) long</li>
                <li>Adjustable Belly Strap</li>
                <li>18" footstrap</li>
              </ul>
            </tab>
            <tab name="Dimensions" class="dims" style="margin-left: 5px;">
              <p>Width: 25.5" (64.8cm)</p>
              <p>Length 86” (218,4cm)</p>
              <p>Canopy Height 82” (208.3cm)</p>
              <p>Table Height: 23.7" (60.2cm)</p>
              <p>Weight: 245lbs. (111.1kg)</p>
              <p>Weight (with toybox): 280lbs (127kg)</p>
            </tab>
          </tabs>
        </section>
      </div>

      <section id="accessories" class="accessories-wrapper">
        <h2>Accessories for Contrology Cadillac</h2>
      </section>

      <section class="carousel">
        <div class="carousel-wrapper">
          <Carousel
            :perPage="3"
            :perPageCustom="[[0,1],[375,2],[700,3]]"
            :navigationEnabled="true"
            paginationActiveColor="#ffffff"
            paginationColor="#878787"
            :paginationSize="7"
            :navigationNextLabel="nextIcon"
            :navigationPrevLabel="prevIcon"
          >
          <slide>
              <accessory-card
                url="cadillac-flash-cards"
                product="Cadillac"
                src="contrology_cadillacflashcards_teaser01@1x.jpg"
                src2="contrology_cadillacflashcards_teaser01@2x.jpg"
                alt="Cadillac Flashcards product photo"
                caption="Cadillac Flashcards"
                badge="new"
              />
            </slide>
            <slide>
              <accessory-card
                url="airplane-board"
                product="Cadillac"
                src="cad-airplaneboard1@1x.jpg"
                src2="cad-airplaneboard1@2x.jpg"
                alt="Airplane Board product photo"
                caption="Airplane Board"
              />
            </slide>
            <slide>
              <accessory-card
                url="kuna-board"
                product="Cadillac"
                src="cad-smkunaboard1@1x.jpg"
                src2="cad-smkunaboard1@2x.jpg"
                alt="Kuna Board product photo"
                caption="Kuna Board (small)"
              />
            </slide>
            <slide>
              <accessory-card
                url="jpack-springs"
                product="Cadillac"
                src="jpack-springs1@1x.jpg"
                src2="jpack-springs1@2x.jpg"
                alt="Jpack Springs product photo"
                caption="Jpack Springs"
              />
            </slide>
            <slide>
              <accessory-card
                url="cadillac-leg-springs"
                product="Cadillac"
                src="cadillac-armsprings1@1x.jpg"
                src2="cadillac-armsprings1@2x.jpg"
                alt="Cadillac Arm springs close up"
                caption="Cadillac Arm Springs"
              />
            </slide>
            <slide>
              <accessory-card
                url="cadillac-arm-springs"
                product="Cadillac"
                src="cadillac-legsprings1@1x.jpg"
                src2="cadillac-legsprings1@2x.jpg"
                alt="Cadillac Leg springs close up"
                caption="Cadillac Arm Springs"
              />
            </slide>
            <slide>
              <accessory-card
                url="neck-stretcher"
                product="Cadillac"
                src="cad-neckstretcher1@1x.jpg"
                src2="cad-neckstretcher1@2x.jpg"
                alt="Neck Stretcher product photo"
                caption="Neck Stretcher"
              />
            </slide>
          </Carousel>
        </div>
      </section>

      <testimonial
        src="quotebanner-cadillac@1x.jpg"
        src2="quotebanner-cadillac@2x.jpg"
        alt="Photo of Jay Grimes working with student on a Contrology Cadillac"
      >
        “The Contrology Cadillac feels so supportive. The dense foam gives the body excellent feedback. The way the canopy is connected to the table makes it feel like the sturdiest Cadillac I’ve ever been on.<br/><br/>And the trap door for storage is just the smartest and coolest idea!”<br/><br/>
        <span>~Carrie Shanafelt, Owner, <a href="https://www.fortepilatesboise.com/" title="Learn more" target="_blank">Forté Pilates</a></span>
      </testimonial>
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/dGmm2r599aA?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal2" @close="showModal2 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/IZdbH2k_g5Y?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
import CtaButton from "@/components/CtaButton.vue";
import ProdAccordion from "@/components/ProdAccordion.vue";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import AccessoryCard from "@/components/AccessoryCard.vue";
import Testimonial from "@/components/Testimonial.vue";
import Modal from '@/components/Modal.vue';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: "cadillac",

  metaInfo: {
    title: "Classical Pilates Cadillac - Contrology Cadillac",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "This Classical Pilates Cadillac is engineered for maximum stability, efficient adjustment and vintage feel. Check out our Contrology Cadillac  to see for yourself."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    CtaButton,
    ProdAccordion,
    Tabs,
    Tab,
    AccessoryCard,
    Testimonial,
    Modal,
    Carousel,
    Slide
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      modalExists: false, // Check featured image for video
      showModal: false, // Video modal in photogrid
      showModal2: false, // Video modal in photogrid
      photoId: "1",
      product: {
        label: "Select a Cadillac",
        value: "",
        key: "name"
      },
      option1: {
        label: "Select a Color",
        value: "",
        key: "color"
      },
      option2: {
        label: "Select a Handle",
        value: "",
        key: "handle"
      },
      products: [
        // Product options
        {
          prodid: 41278349148353,
          partnumber: 17037,
          price: 4900,
          name: "Contrology Cadillac",
          color: "Black Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349738177,
          partnumber: 17123,
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Black Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349181121,
          partnumber: "17133C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Black Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349770945,
          partnumber: "17134C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Black Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349082817,
          partnumber: "17123C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Adobe White Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349672641,
          partnumber: "17136C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Adobe White Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349115585,
          partnumber: "17135C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Adobe White Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349705409,
          partnumber: "17137C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Adobe White Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349213889,
          partnumber: "17135C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Burgundy Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349803713,
          partnumber: "17136C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Burgundy Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349246657,
          partnumber: "17123C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Burgundy Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349836481,
          partnumber: "17137C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Burgundy Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349279425,
          partnumber: "17135C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Dark Cherry Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349869249,
          partnumber: "17136C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Dark Cherry Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349312193,
          partnumber: "17123C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Dark Cherry Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349902017,
          partnumber: "17137C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Dark Cherry Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349344961,
          partnumber: "17135C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Greystone Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349934785,
          partnumber: "17136C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Greystone Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349377729,
          partnumber: "17123C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Greystone Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349967553,
          partnumber: "17137C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Greystone Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349410497,
          partnumber: "17135C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Oak Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278350000321,
          partnumber: "17136C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Oak Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349443265,
          partnumber: "17123C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Oak Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278350033089,
          partnumber: "17137C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Oak Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349476033,
          partnumber: "17135C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Sage Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278350065857,
          partnumber: "17136C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Sage Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349508801,
          partnumber: "17123C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Sage Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278350098625,
          partnumber: "17137C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Sage Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349541569,
          partnumber: "17135C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Storm Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278350131393,
          partnumber: "17136C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Storm Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349574337,
          partnumber: "17123C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Storm Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278350164161,
          partnumber: "17137C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Storm Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278349607105,
          partnumber: "17135C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Wedgewood Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278350196929,
          partnumber: "17136C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Wedgewood Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278349639873,
          partnumber: "17123C",
          price: 4900,
          name: "Contrology Cadillac",
          color: "Wedgewood Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278350229697,
          partnumber: "17137C",
          price: 5300,
          name: 'Contrology Cadillac with toybox',
          color: "Wedgewood Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
      ]
    };
  },

  computed: {
    nextIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.51922 0.624325C1.21151 -0.208109 2.33394 -0.208109 3.02623 0.624325L12.4808 11.9927C13.1731 12.8252 13.1731 14.1748 12.4808 15.0073L3.02624 26.3757C2.33395 27.2081 1.21152 27.2081 0.519224 26.3757C-0.173069 25.5432 -0.173069 24.1936 0.519224 23.3612L8.72026 13.5L0.51922 3.63883C-0.173073 2.8064 -0.173073 1.45676 0.51922 0.624325Z" fill="black"/>
</svg>`;
    },

    prevIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.4808 26.3757C11.7885 27.2081 10.6661 27.2081 9.97377 26.3757L0.519221 15.0073C-0.173073 14.1748 -0.173073 12.8252 0.519222 11.9927L9.97377 0.624325C10.6661 -0.208107 11.7885 -0.208107 12.4808 0.624325C13.1731 1.45676 13.1731 2.8064 12.4808 3.63884L4.27974 13.5L12.4808 23.3612C13.1731 24.1936 13.1731 25.5432 12.4808 26.3757Z" fill="black"/>
</svg>`;
    }
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    },

    // Does featured image include a video?
    initModal() {
      this.modalExists = true;
    },

    setId(id) {
      this.photoId = id;
    },

    // Open modal from featured image
    openModal() {
      if ( this.modalExists && this.photoId === "1" ) {
        this.showModal = true;
        this.modalExists = false // Reset prop
      }
      if ( this.modalExists && this.photoId === "6" ) {
        this.showModal2 = true;
        this.modalExists = false // Reset prop
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.product-info {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid #010101;
  margin-top: 30px;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

.features li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg")
    no-repeat left center;
  padding-left: 20px;
}

.included li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg")
    no-repeat left center;
  padding-left: 40px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}

li:last-of-type {
  border-bottom: none;
}

.accordion-wrapper p {
  margin-left: 30px;
}

.tabs-wrapper {
  display: none;
}

.accessories-wrapper {
  margin-top: 30px;
}

.accessories-wrapper h2 {
  margin: 2.5rem 0 1.5rem;
}

.accessories {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

.patent-info {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 3;
  order: 3;
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 12px;
}

::v-deep .VueCarousel {
  max-width: 900px;
  margin: 0 auto;
}

::v-deep .VueCarousel-dot-container {
  display: block;
  margin-top: 0 !important;
  padding: 0;
  text-align: right;
}

::v-deep .VueCarousel-dot {
  margin-top: 0 !important;
  padding: 0 7px !important;
}

::v-deep .VueCarousel-navigation-button:focus {
  outline: none;
}

::v-deep .VueCarousel-navigation-prev {
  left: 4px;
}

::v-deep .VueCarousel-navigation-next {
  right: 4px;
}

::v-deep .VueCarousel-navigation--disabled {
  opacity: 0.3;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 150%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }

  .tabs-wrapper {
    display: block;
    max-width: 810px;
    margin: auto auto 50px;
  }

  .dims {
    max-width: 650px;
    margin: 0 auto;
  }

  .dims table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .dims th,
  .dims td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .dims td {
    height: 50px;
  }

  .dims tr th:first-of-type,
  .dims tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .product-info {
    border: none;
    box-shadow: none;
  }

  li:last-of-type {
    border-bottom: 1px solid #c4c4c4;
  }

  .accordion-wrapper {
    display: none;
  }

  .accessories {
    flex-flow: row wrap;
    max-width: 600px;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 0;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  ::v-deep .modal-card-wrapper {
    top: 100%;
  }

  .icon-link {
    margin: 0;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .product-info {
    grid-column: 2 / span 1;
    grid-row: 2 / span 3;
    margin-right: 30px;
    margin-top: 5px;
    max-width: 512px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 40%;
  }

  .icon-link {
    margin: 1px;
    height: 27px;
  }

  ::v-deep .tabs-details {
    background-color: transparent;
    padding: 10px 0 0;
  }
}
</style>
